import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseDialog = _resolveComponent("BaseDialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_BaseDialog, {
      "is-open": _ctx.showConfirm,
      "onUpdate:is-open": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showConfirm) = $event)),
      title: _ctx.labels.confirmDeleteProfileTitle,
      description: _ctx.labels.confirmDeleteProfileDescription,
      "cancel-button": _ctx.labels.cancelDeleteProfileButton,
      "confirm-button": _ctx.labels.confirmDeleteProfileButton,
      "confirm-method": _ctx.confirmDelete
    }, null, 8, ["is-open", "title", "description", "cancel-button", "confirm-button", "confirm-method"]),
    _createVNode(_Transition, {
      name: "o-anim-fade-300",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.showSuccess)
          ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.labels.deleteProfileSuccess), 1))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "text-dusty-grey c-magic-line",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.tryDelete && _ctx.tryDelete(...args)), ["prevent"]))
            }, _toDisplayString(_ctx.labels.deleteProfileButton), 1))
      ]),
      _: 1
    })
  ]))
}